import getParameterFromErrorResponse from '@/services/recommandation/parameterFromErrorResponse';

export const API_SPOT_HAVAS_ERROR_REFERENCE = 'API_SPOT_HAVAS_ERROR_REFERENCE';

export function erreurReferenceHavas(message, messages) {
  const [reference, ...reste] = getParameterFromErrorResponse(message);
  messages.push({
    message: 'validation.referenceHavasInvalide',
    parametres: {
      reference,
      detail: reste.join('@'),
    },
  });
}
